import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import RotateOverlay from './components/RotateOverlay';
import { setBackButtonUrl } from '../../store/uiSlice';
import { ASSET } from '../../utils/sopGame';
import './rules.css';

const RULES = [
  "Uncover India's untold historical secrets while celebrating Independence Day",
  'The game consist of 7 stages, each stage with its set of questions',
  'For every correct answer you will earn points',
  'Correct answers will turn green and wrong answers will turn red',
  "Highlights the significance of historical awareness in fostering patriotism and a profound connection to India's past, present, and future",
];

export default function RulesPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBackButtonUrl('/'));
  }, [dispatch]);

  return (
    <div className="sop-rules">
      <RotateOverlay />
      <div className="sop-rules-scene">
        <article className="sop-book">
          <section className="sop-page sop-page-active">
            <div
              className="sop-front sop-rules-front"
              style={{ backgroundImage: `url(${ASSET.img('bg2.png')})` }}
            >
              <div className="sop-rules-content">
                <h4 className="sop-title">RULES</h4>
                <ul className="sop-rule-list">
                  {RULES.map((r) => (
                    <li key={r}>{r}</li>
                  ))}
                </ul>
                <button type="button" className="sop-rule-next" onClick={() => navigate('/game')}>
                  <img src={ASSET.img('next.png')} alt="Next" />
                </button>
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  );
}
